import styled from '@emotion/styled';
import { Chip, chipClasses, Grid } from '@mui/material';
import { useState } from 'react';
import { IDocument } from 'wisestep-api';
import { WsColorsNew, WsTypography } from 'wisestep-base';

import CandidateResume from '../../childComponets/CandidateResume';

const StyledDocumentChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ selected }) => ({
  backgroundColor: selected ? WsColorsNew.brand_light_pressed_25 : '',
  maxWidth: 150,
  borderRadius: 12,
  [`& .${chipClasses.label}`]: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

const DocumentListDisplay = ({
  documents,
  title = 'Documents uploaded',
}: {
  documents: IDocument[];
  title?: string;
}) => {
  const [selectedDocument, setSelectedDocument] = useState<number>(0);
  return (
    <Grid display="flex" direction="column" rowGap={1}>
      <WsTypography bold>{title}</WsTypography>
      <Grid container columnGap={1} mb={1}>
        {documents?.map((document, index) => (
          <StyledDocumentChip
            key={index}
            size="medium"
            label={document?.originalName ?? 'Candidate'}
            color="primary"
            variant="outlined"
            selected={selectedDocument === index}
            onClick={() => setSelectedDocument(index)}
          />
        ))}
      </Grid>
      <CandidateResume
        job={null}
        pdfResumeUrl={documents?.[selectedDocument]?.documentLocation ?? ''}
        resumeLocation={documents?.[selectedDocument]?.documentLocation ?? ''}
        resumeFileName={documents?.[selectedDocument]?.originalName ?? 'file'}
      />
    </Grid>
  );
};

export default DocumentListDisplay;
